/* ===============================
   WAIT FOR JQUERY
================================ */
(function waitForjQuery(callback) {
  if (window.jQuery) {
    callback();
  } else {
    setTimeout(function () {
      waitForjQuery(callback);
    }, 50);
  }
})(function () {

  jQuery(document).ready(function ($) {

    /* ===============================
       PRODUCT GALLERY – VIEW MORE
    ================================ */
    var hiddenElements = $('#product_gallery > *:gt(0)').detach();

    $('#product_gallery').on('click', '.fancybox', function () {
      $('#product_gallery').append(hiddenElements);
    });

    /* ===============================
       SWATCH PRICE SYNC
    ================================ */
    $('.swatch-element').on('click', function () {
      setTimeout(function () {
        var newPrice = $('.pricef span').html();
        $('.price-b span').html(newPrice);
      }, 0);
    });

  });
});

/* ===============================
   HEADER SCROLL CLASS
================================ */
window.addEventListener('scroll', function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  if (window.scrollY > 1) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});

/* ===============================
   PAGE REDIRECTS
================================ */
(function () {
  var currentUrl = window.location.href;

  if (currentUrl === "https://whiteduckoutdoors.com/pages/heroes-discount") {
    window.location.replace("https://whiteduckoutdoors.com/pages/military-discount");
  }

  if (currentUrl === "https://whiteduckoutdoors.com/collections/military-surplus-tent?page=2") {
    window.location.replace("https://whiteduckoutdoors.com/collections/military-surplus-tent");
  }
})();
